// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__xqXjn","flag":"LanguageSwitcher_flag__pw7oo","flagActive":"LanguageSwitcher_flagActive__ruQbE"};